import { Link } from 'react-router-dom';
import { PeicarLogo, IconInstagram, IconLinkedIn } from './icons';
import {
  WA_PHONE, EMAIL, CITIES, ADDRESS_LINES, INSTAGRAM_URL, LINKEDIN_URL,
} from '../../config';

/* FooterNuevo — port del Footer del handoff "Secciones Peicar".
 * Diferencias acordadas vs handoff:
 *   - Datos de contacto REALES (config.js), no los del diseño.
 *   - Se agrega la dirección física (no estaba en el diseño).
 *   - © con año dinámico; links legales a las rutas reales. */
const FooterNuevo = () => (
  <footer className="pei-foot">
    <div className="top">
      <div className="col">
        <PeicarLogo className="logo" />
        <div className="slogan">
          <span className="t1">fácil.</span> <span className="t2">rápido.</span>{' '}
          <span className="t3">digital.</span>
        </div>
        <p className="small">
          Somos una empresa mexicana que hace las cosas bien. Arrendamiento de
          autos nuevos y seminuevos, sin papeleo y con todo incluido.
        </p>
        <div className="socials">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><IconInstagram /></a>
          <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><IconLinkedIn /></a>
        </div>
      </div>
      <div className="col">
        <h4>Peicar</h4>
        <a href="#incluido">Qué incluye</a>
        <a href="#proceso">Cómo funciona</a>
        <a href="#fiscal">Beneficio fiscal</a>
        <Link to="/login">Iniciar sesión</Link>
      </div>
      <div className="col">
        <h4>Contacto</h4>
        <span className="li"><b>WhatsApp</b><br />{WA_PHONE}</span>
        <span className="li">{EMAIL}</span>
        <span className="li">{CITIES}</span>
        <span className="li">{ADDRESS_LINES[0]}<br />{ADDRESS_LINES[1]}</span>
      </div>
    </div>
    <div className="rule"></div>
    <div className="legal">
      <span>© {new Date().getFullYear()} Peicar · La llave a tu movilidad</span>
      <span className="links">
        <Link to="/aviso-de-privacidad">Aviso de privacidad</Link>
        <Link to="/terminos-condiciones">Términos y condiciones</Link>
      </span>
    </div>
  </footer>
);

export default FooterNuevo;
